// External libraries
import debounce from 'lodash.debounce';

// Internal modules
import { getLocale } from '@/lib';
import { conditionallyCalculateShippingAndTaxes } from '@/components/Shipping/utils';
import { handleCountryChange } from '../shared';
import { shouldDebounceCountryChange } from './utils';

const DEBOUNCE_DELAY = 1200;
const changeCountry = shouldDebounceCountryChange()
  ? debounce(handleCountryChange, DEBOUNCE_DELAY)
  : handleCountryChange;

const getCountryChangeHandler = isDisabled => {
  return (e, toCountry) => {
    e.preventDefault();
    if (isDisabled) {
      return;
    }

    const fromCountry = getLocale().country;
    changeCountry({ fromCountry, toCountry });
    conditionallyCalculateShippingAndTaxes();
  };
};

export { getCountryChangeHandler };
